module.exports = __webpack_public_path__ + "static/media/Boys-Hostel.432242e9.jpg";